import { Upload } from 'antd';
import styled from 'styled-components';

export const DocWrap = styled(Upload)`
	& .ant-upload {
		width: 100%;
	}
	& .ant-upload-list {
		margin-top: -6px !important;
	}
	& .ant-upload-list.ant-upload-list-picture {
		flex: 1;
		overflow-y: auto;
	}

	/* 拖拽相关样式 */
	& .ant-upload-list-item {
		transition: all 0.2s ease-in-out;
	}

	/* 拖拽中的样式 */
	& .ant-upload-list-item.dragging {
		opacity: 0.5;
		cursor: grabbing;
	}

	/* 拖拽目标高亮样式 */
	& .ant-upload-list-item.drop-target {
		border: 1px dashed #1890ff;
		border-radius: 4px;
		background-color: #e6f7ff;
		padding: 4px;
	}
`;
